import CollectionToAddPost from "./collection-to-add-post";

export default CollectionToAddPost;